<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
  export default{
    name: 'APP'
  }
</script>



// WEBPACK FOOTER //
// src/App.vue